import { TReduxActions } from '../../types/redux';
import { EConsultationRequestActions } from '../../constants/actionTypes/consultationRequest';
import { IConsultationRequestState } from '../../types/redux/states';

export const initialState: IConsultationRequestState = {
  activeStep: null,
};

export function consultationRequestReducer(state: IConsultationRequestState = initialState, action: TReduxActions) {
  switch (action.type) {
    case EConsultationRequestActions.SetActiveStep:
      return {
        ...state,
        activeStep: action.payload,
      };

    default:
      return state;
  }
}
